import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ArButton.scss';

export default function Arbutton(props) {
    let {arMob} = {...props.ui}
    const arbuttonName = window.isIpadOrIphoneforAr ? 'btnXR-iphone' : 'btnXR';
    const classes =  window.isIpadOrIphoneforAr ? 'arButton d-flex' : 'arButton';
    const arbtnClickHandler = (e) => {
      
      // let target = e.target.closest(".arButton");
      // console.log(target.id);
      // if(target.id === '')
      // window.usdzRTClicked();
      console.log('arbtnClickHandler called..... ', window.isIpadOrIphoneforAr)
      if(window.isIpadOrIphoneforAr){
          window.usdzRTClicked();
      }
    }
    return (
      <React.Fragment>
        <button  role="presentation" id={arbuttonName} className={classes} onClick={arbtnClickHandler}>
            <img  role="presentation" className='icon' src='images/menu/ar-icon-white.svg' />
            <span className='text' data-contentwidth={props.calcHtmlElementNoWrapWidth(arMob, 13)}>{arMob}</span>
        </button>
      </React.Fragment>
 )
}